module.exports = __webpack_public_path__ + "4d593832843363e0796ae8d7318ba5b9.png";